import { z } from 'zod';

import { KitComponentInputSchema, KitSlotInputSchema } from './kit.schemas.js';

/** BR-PRD-47 — composição FIXED (components) OU SLOT (slots), exclusiva por kit. */
export const ReviseKitCompositionBodySchema = z
  .object({
    components: z.array(KitComponentInputSchema).min(1).max(100).optional(),
    slots: z.array(KitSlotInputSchema).min(1).max(100).optional(),
  })
  .refine((body) => (body.components === undefined) !== (body.slots === undefined), {
    message: 'Provide either components (FIXED) or slots (SLOT), not both',
  });

export const ReviseKitCompositionResponseSchema = z.object({
  kitId: z.uuid(),
  version: z.number().int(),
});

export type ReviseKitCompositionBody = z.infer<typeof ReviseKitCompositionBodySchema>;
export type ReviseKitCompositionResponse = z.infer<typeof ReviseKitCompositionResponseSchema>;
